module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-37-8fcc03dabac4b10bc499d188451bc7d4.svg";